var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component",staticClass:"error"},[(_vm.errorObject && _vm.showView)?_c('error-template',{attrs:{"error-object":_vm.errorObject}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }